import styled from 'styled-components';

export const DocumentList = styled.div`
  display: table;
  width: 100%;
`;

export const DocumentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;

export const DocumentName = styled.span`
  font-size: 14px;
`;
